import { CONCEPTOS_EXTERNOS } from '../actions/types';

const normalize = (val) => {
    if (val === null || val === undefined) return '';
    return (val + '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
};

const initialState = {
    listado: [],
    filtrado: [],
    error: null
};

export default function conceptosExternosReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case CONCEPTOS_EXTERNOS.LISTAR: {
            const listado = Array.isArray(payload) ? payload : [];
            return {
                ...state,
                listado,
                filtrado: listado,
                error: null
            };
        }

        case CONCEPTOS_EXTERNOS.FILTRAR: {
            const texto = normalize(payload);
            if (!texto) {
                return { ...state, filtrado: state.listado };
            }

            const filtrado = state.listado.filter((c) => {
                const detalle = normalize(c?.detalle);
                const unidad = normalize(c?.unidad?.nombre);

                return detalle.includes(texto) || unidad.includes(texto);
            });

            return { ...state, filtrado };
        }

        case CONCEPTOS_EXTERNOS.LIMPIAR:
            return { ...initialState };

        case CONCEPTOS_EXTERNOS.ERROR:
            return { ...state, error: payload };

        default:
            return state;
    }
}
